import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';

class SMReservationEditViewEventType extends React.Component{

  selectBoxDidChangeValue(e) {
    this.props.delegate.changeEventType(e.currentTarget.name, e.currentTarget.value);
  }
  
  render() {
    const room = this.props.room;
    const reservation = this.props.reservation;
    
    let eventTypes = [];
    let selectedValue = null;

    for (let i = 0; i < room.event_types.length; i++) {
      eventTypes.push(
        {value: room.event_types[i].name, label: room.event_types[i].name_text}
      );

      if (reservation.event_type == room.event_types[i].name) {
        selectedValue = room.event_types[i].name;
      }
    }

    return (
      <td>
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox
              name='event_type'
              items={eventTypes}
              selectedValue={selectedValue}
              delegate={this}
              options={{className: 'w140'}} />
          </label>
        </span>
      </td>
    );
  }
}

SMReservationEditViewEventType.propTypes = {
  reservation: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewEventType;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewEventType.jsx